<template>
  <div class="header-wrapper">
    <div class="new-page-header">
      <div
        class="nav-title"
        @mouseover="showTag()"
        @mouseout="hideTag()"
      >
        <a class="pointer" @click="toHome"><img src="../../../assets/img/logo_2018.png">
          <div
            v-show="historyHeader && isShowTag"
            class="little-tag"
          >
            <img src="../../../assets/img/回主页图标.png">
            <img src="../../../assets/img/回主页.png">
          </div>
        </a>
      </div>

      <menu-nav
        v-show="historyHeader"
        :menu-list="menuList"
        @no-privilidge="loginShow"
      />

      <div class="nav-user">
        <span
          v-show="!isLogin"
          class="white-text pointer"
          @click="loginShow"
        >登录</span>
        <el-dropdown v-show="isLogin">
          <span class="el-dropdown-link">
            <img
              src="../../../assets/img/1.png"
              data-toggle="dropdown"
            >
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a href="#/userInformation">个人中心</a></el-dropdown-item>
            <el-dropdown-item><a
              href="javascript:;"
              @click="logout"
            >安全退出</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { menuList } from './menuListData'

import menuNav from './menuList'

export default {
  name: 'CirdHeader',
  components: { menuNav },
  props: {
    historyHeader: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuList: menuList,
      isShowTag: false,
      homeSite: 'http://www.reformdata.org/records/'
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  watch: {
    isLogin: function () {
      this.setAuthor()
    }
  },
  mounted () {
    this.setAuthor()
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),
    ...mapActions({
      logout: 'userLogout'
    }),
    setAuthor () {
      this.menuList.forEach(i => {
        i.isLogin = this.isLogin || [201, 202, 203].indexOf(i.Id) !== -1
      })
    },
    // 显示tag
    showTag () {
      this.isShowTag = true
    },
    hideTag () {
      this.isShowTag = false
    },
    toHome () {
      window.location.href = this.homeSite
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/common/header/header.out.vue